module.exports = __webpack_public_path__ + "img/RMR Login.88699410.png";